"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * `juxt` applies a list of functions to a list of values.
 *
 * @example
 * ```ts
 * const range = juxt([Math.min, Math.max])(1, 2, 3, 4); // [1, 4]
 *
 * // with pipe
 * const entries = (obj: { a: number; b: number }) =>
 *   pipe(
 *     [Object.keys, Object.values] as const,
 *     juxt,
 *     (f) => f(obj),
 *     apply(zip),
 *     toArray,
 *   );
 *
 * entries({ a: 1, b: 2 }); // [ ["a", 1], ["b", 2] ]
 * ```
 *
 * see {@link https://fxts.dev/docs/pipe | pipe}, {@link https://fxts.dev/docs/apply | apply}
 */
function juxt(fs) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fs.map(function (f) { return f.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false)); });
    };
}
exports.default = juxt;
//# sourceMappingURL=juxt.js.map